/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import SmartTable from 'shared/ui/components/tables/SmartTable.vue';

/**
 * @typedef {object} DeletedDoc
 * @prop {string} id
 * @prop {string} name
 * @prop {string} original_fp_type
 * @prop {number} deleted_timestamp
 * @prop {string} deleted_by
 */

const __vue_script__ = {
    name: 'DeletedDocs',

    components: { SmartTable },

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            currentPage: 1,
            docs: [],
            eventId: this.params.event.id || this.params.event._id,
            limit: this.$services.documents.MAX_DOCS_PER_PAGE,
            loading: false,
            canEditDocument: false,
            total: null,
        };
    },

    watch: {
        limit() {
            this.loadDocs();
        }
    },

    async created() {
        this.loading = true;
        this.canEditDocument = this.$services.user.isDeveloper() && this.$services.blueprint.isModuleInstalled('document-editor');
        await this.loadDocs();
        this.loading = false;
    },

    methods: {
        /**
         * Loads the collection to display on the table
         *
         * @param {number} page the page to load
         */
        async loadDocs(page = this.currentPage) {
            try {
                const { total, items } = await this.$services.documents.listDeletedDocs(this.eventId, page, this.limit);

                if (!items.length && page > 1) {
                    console.warn('[DeletedDocs] No docs on page %d, going to page %d', page, page - 1);
                    this.$refs['docs'].selectPage(page - 1);
                    return;
                }

                this.docs = items;
                this.total = total;
                this.currentPage = page;

            } catch (error) {
                console.error('[DeletedDocs] Could not load initial data', error);

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('support.deleted_docs.messages.could_not_load').toString(),
                    type: 'warning',
                    duration: 5000
                });
            }
        },

        /** @param {string[]} ids */
        async restore(ids) {
            try {
                await this.$services.documents.restoreDeletedDocs(this.eventId, ids);
                this.$refs['docs'].unselectAll();
                await this.loadDocs();

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.tc('support.deleted_docs.messages.restore_success', ids.length, { count: ids.length }).toString(),
                    type: 'success',
                    duration: 5000
                });

            } catch (error) {
                console.error('[DeletedDocs] Could not restore data', error);

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('support.deleted_docs.messages.could_not_restore').toString(),
                    type: 'warning',
                    duration: 5000
                });
            }
        },

        /** @param {string} id the ID of the document to edit */
        editDocumentLink(id) {
            const { controllers } = this.$services.blueprint.getModuleByName('document-editor');
            const route = controllers['document-editor'].route;
            const path = route.replace(':eventId', this.eventId);
            return `${path}?document=${id}`;
        },

        /** @param {DeletedDoc} item */
        sameTz(item) {
            const localTz = this.$utils.time.tsToLongDateTimeFormat(item.deleted_timestamp);
            const eventTz = this.$utils.time.tsToLongDateTimeFormat(item.deleted_timestamp, this.params.event.timezone);
            console.info(localTz !== eventTz, localTz, eventTz);
            return localTz === eventTz;
        },

        /** @param {DeletedDoc} item */
        formatDeletedBy(item) {
            return (item.deleted_by || '')
                .replace(' soft deleted ', '')
                .replace('via ', ' - ');
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deleted-docs"},[(_vm.loading)?_c('loader',{attrs:{"status":_vm.loading}}):[(!_vm.docs.length)?_c('div',{staticClass:"alert alert-info"},[_c('p',[_vm._v(_vm._s(_vm.$t('support.deleted_docs.no_docs')))])]):_c('smart-table',{ref:"docs",attrs:{"track-by":"id","items":_vm.docs,"items-per-page":_vm.limit,"selectable":true,"total-items":_vm.total || _vm.docs.length},on:{"next":_vm.loadDocs,"previous":_vm.loadDocs,"select-page":_vm.loadDocs},scopedSlots:_vm._u([{key:"bulk-actions",fn:function(ref){
var selectedItems = ref.selectedItems;
return [_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.restore(selectedItems.map(function (i) { return i.id; }))}}},[_vm._v(_vm._s(_vm.$t('support.deleted_docs.restore')))])]}},{key:"headers",fn:function(ref){return [_c('th',[_vm._v(_vm._s(_vm.$t('support.deleted_docs.headers.name')))]),_c('th',[_vm._v(_vm._s(_vm.$t('support.deleted_docs.headers.original_fp_type')))]),_c('th',[_vm._v(_vm._s(_vm.$t('support.deleted_docs.headers.deleted_timestamp')))]),_c('th',[_vm._v(_vm._s(_vm.$t('support.deleted_docs.headers.deleted_by')))]),_c('th',{staticClass:"actions"})]}},{key:"row",fn:function(ref){
var item = ref.item;
return [_c('td',[(_vm.canEditDocument)?_c('a',{attrs:{"href":_vm.editDocumentLink(item.id)}},[_vm._v(_vm._s(item.name))]):_c('span',[_vm._v(_vm._s(item.name))])]),_c('td',[_c('i',{class:_vm.$utils.assets.getIconForType(item.original_fp_type)}),_vm._v(" "),_c('code',[_vm._v(_vm._s(item.original_fp_type))])]),_c('td',{staticClass:"tz"},[(_vm.sameTz(item))?[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.$t('support.deleted_docs.headers.deleted_timestamp_tz', [Intl.DateTimeFormat().resolvedOptions().timeZone])),expression:"$t('support.deleted_docs.headers.deleted_timestamp_tz', [Intl.DateTimeFormat().resolvedOptions().timeZone])"}]},[_vm._v(_vm._s(_vm.$utils.time.tsToLongDateTimeFormat(item.deleted_timestamp)))])]:[_c('small',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.$t('support.deleted_docs.headers.deleted_timestamp_tz', [Intl.DateTimeFormat().resolvedOptions().timeZone])),expression:"$t('support.deleted_docs.headers.deleted_timestamp_tz', [Intl.DateTimeFormat().resolvedOptions().timeZone])"}]},[_c('i',{staticClass:"ic-monitor"}),_vm._v(" "+_vm._s(_vm.$utils.time.tsToLongDateTimeFormat(item.deleted_timestamp)))]),_c('br'),_c('small',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.$t('support.deleted_docs.headers.deleted_timestamp_tz', [_vm.params.event.timezone])),expression:"$t('support.deleted_docs.headers.deleted_timestamp_tz', [params.event.timezone])"}]},[_c('i',{staticClass:"ic-globe"}),_vm._v(" "+_vm._s(_vm.$utils.time.tsToLongDateTimeFormat(item.deleted_timestamp, _vm.params.event.timezone)))])]],2),_c('td',[_c('span',[_vm._v(_vm._s(_vm.formatDeletedBy(item)))])]),_c('td',{staticClass:"actions"},[_c('button',{staticClass:"btn btn-icon btn-warn",on:{"click":function($event){return _vm.restore([item.id])}}},[_c('i',{staticClass:"icon-undo"}),_vm._v(_vm._s(_vm.$t('support.deleted_docs.restore')))])])]}}])})]],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "DeletedDocs.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__